import React, {useState, useEffect} from 'react';
import MaterialTable from 'material-table';
import { forwardRef } from 'react';
import AddBox from '@mui/icons-material/AddBox';
import ArrowUpward from '@mui/icons-material/ArrowUpward';
import Check from '@mui/icons-material/Check';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import Clear from '@mui/icons-material/Clear';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import Edit from '@mui/icons-material/Edit';
import FilterList from '@mui/icons-material/FilterList';
import FirstPage from '@mui/icons-material/FirstPage';
import LastPage from '@mui/icons-material/LastPage';
import Remove from '@mui/icons-material/Remove';
import SaveAlt from '@mui/icons-material/SaveAlt';
import Search from '@mui/icons-material/Search';
import ViewColumn from '@mui/icons-material/ViewColumn';
import InfoIcon from '@mui/icons-material/Info';
import {
  IconButton,
  Paper,
  Avatar,
  DialogTitle,
  DialogContent,
  DialogActions,
  Dialog,
  Badge,
  Button,
  Grid,
  Tooltip,
  CircularProgress
} from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import SaveIcon from '@mui/icons-material/Save';

import { lighten } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import PublishTwoToneIcon from '@mui/icons-material/PublishTwoTone';
import ImageUploader from 'react-images-upload';
import Resizer from 'react-image-file-resizer';

import Title from '../../../components/Title';
import useStylesMain from '../../../useStyles';
import socket from '../../../services/socket';
import api from '../../../services/api'


function Item(props) {
    const seller_id = props.seller_id
    return <>
        <Button 
            onClick={()=>{
            props.setSelectedSeller(seller_id)
            props.setOpen(true)
            }}
        >
            <Badge
            overlap="circular"
            anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
            }}
            badgeContent={<PublishTwoToneIcon color="secondary"/>}
            >
                <Avatar alt="I" src={props.img_url} className={props.style}/> 
            </Badge>
        </Button>
    </>;
}


const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
    },
    paper: {
      width: '100%',
      marginBottom: theme.spacing(2),
    },
    table: {
      minWidth: 750,
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
    tableRow: {
      "&$selected, &$selected:hover": {
        backgroundColor: lighten(theme.palette.primary.light, 0.5)
      }
    },
    tableCell: {
      "$selected &": {
        color: lighten(theme.palette.primary.light, 0.5)
      }
    },
    selected: {},
    avatar_image:{
        width:  "50px",
        height: "50px",
        borderRadius: "50%",
      },

      avatar_image_big:{
        width:  "150px",
        height: "150px",
        borderRadius: "50%",
      },

    avatar_text:{
      color: "#14143c",
      backgroundColor: "white",
      padding: "3px",
      fontFamily: "Coboto",
      fontSize:15
    }
  }));



function UpdateAvatar(props){
    const classes = useStyles();
    const {open,setOpen,selectedSeller,store_id} = props
    const [image,setImage] = React.useState([])
    const [loadingImage,setLoadingImage] = React.useState(false)

    const handleClose = () => {
        setOpen(false);
    };

    function onDrop(picture) {
        setImage(
            picture.slice(-1)
        );
    }

    const resizeFile = (file) => new Promise(resolve => {
        Resizer.imageFileResizer(file, 128, 128, 'JPEG', 100, 0,
        uri => {
          resolve(uri);
        },
        'base64'
        );
    });

    const onChange = async (event) => {
        const file = image[0]
        const image2 = await resizeFile(file);
        setImage(image2)
    }


    async function sendDataAvatarHttp(){
        try{
            setLoadingImage(true)
            let data = { 
                'seller_id':selectedSeller,
                'img_url': image
            }
            // const token = await sessionStorage.getItem('token')
            await api.post('/vezo/editSellers/sendDataAvatar/'+store_id,data);
            setLoadingImage(false)
            handleClose()
            alert("Atualizado com sucesso, recarregue para visualizar!")
        }
        catch(err){
            console.log(err)
            setLoadingImage(true)
            alert("Erro de atualização, recarregue a página!")
        }
    }
    
    return (
        <div>
      <Dialog open={open} onClose={handleClose} onEscapeKeyDown={handleClose} onBackdropClick={handleClose}>
        <DialogTitle>Editar </DialogTitle>
        {!loadingImage 
        ?
        <DialogContent>
          <form className={classes.container}>
            <Grid container spacing={3}  justifyContent={"center"} direction="row">
                <Grid item >
                    <ImageUploader
                        withIcon={true}
                        buttonText='Choose images'
                        onChange={onDrop}
                        imgExtension={['.jpg']}
                        maxFileSize={5242880}
                    />
                </Grid>
                <Grid item>
                    <Avatar alt="Image" src={image} className={classes.avatar_image_big}/>
                </Grid>
            </Grid>
          </form>
        </DialogContent>
        :
        <div style={{paddingTop:'10px'}}>
            <CircularProgress />
        </div>
        }
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancelar
          </Button>
          <Button 
            value={image}
            onClick={onChange} 
            color="primary">
            Carregar
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="small"
            startIcon={<SaveIcon />}
            onClick={sendDataAvatarHttp}
         >
            Salvar
        </Button>
        </DialogActions>
      </Dialog>
    </div>
    );

}

export default function EditSeller(props) {
    const [isLoading,setIsLoading] = useState(false);
    const classesMain = useStylesMain()
    const classes = useStyles();
    const [store_id,setStore_id] = useState(props.store)
    const [selectedSeller,setSelectedSeller] = useState(null)
    const [open,setOpen] = useState(false)
    const [state, setState] = React.useState({
        columns: [
                { title: 'Avatar', field: '',
                    render: rowData => (
                        <Item img_url={rowData.img_url} setOpen={setOpen} setSelectedSeller={setSelectedSeller} seller_id={rowData.id} style={classes.avatar_image}/>
                  ), 
                },
                { title: 'Nome', field: 'name' },
                { title: 'Sobrenome', field: 'surname' },
                { title: 'Senha', field: 'password',type: 'numeric' },
            ],
            data: []
     })

    useEffect( () => {    
        setIsLoading(true)
        setStore_id(props.store)
        // console.log(props)
        function askSellersInfo(){
          socket.emit('/vezo/addInfo/askSellersInfo',{ 
                          'store_id': store_id,
                        }
                        ,(data)=>{console.log(data);})
        }
      
        async function loadaskSellersInfo(){
          askSellersInfo()
          socket.on('/vezo/addInfo/updateSellersInfo/'+store_id,()=>{
            // When the server sends a updatePaperInfo, it asks for newer intel
            askSellersInfo();
          })
          socket.on('/vezo/addInfo/SellersInfo/'+store_id,(dataDB)=>{
            const data = dataDB.map((row,index)=>{
                return ({    
                    "id": row.id,
                    "name":   row.name,
                    "surname":   row.surname,
                    'img_url': row.image ? Buffer.from(row.image).toString():"I"
                })   
              });
            setState((prevState) => {
                return { ...prevState, data };
            });
            setIsLoading(false)
          });
          return () => socket.disconnect();
        }
        loadaskSellersInfo(); 
      },[props,store_id]);
    
    const tableIcons = {
        Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
        Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
        Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
        Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
        DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
        Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
        Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
        Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
        FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
        LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
        NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
        PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
        ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
        Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
        SortArrow: forwardRef((props, ref) => <ArrowUpward {...props} ref={ref} />),
        ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
        ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
    };

    const newLocalization = {
        error: "Dados não foram encontrados!",
        grouping: {
        groupedBy: "Agrupar por:",
        placeholder: "Drag headers here to group by"
        },
        pagination: {
            labelRowsSelect: 'linhas',
            labelDisplayedRows: '{count} de {from}-{to}',
            firstTooltip: 'Primeira página',
            previousTooltip: 'Página anterior',
            nextTooltip: 'Próxima página',
            lastTooltip: 'Última página'
        },
        toolbar: {
            addRemoveColumns: 'Adicionar ou deletar colunas',
            nRowsSelected: '{0} linha(s) selecionada(s)',
            showColumnsTitle: 'Ver colunas',
            showColumnsAriaLabel: 'Ver colunas',
            exportTitle: 'Exportar',
            exportAriaLabel: 'Exportar',
            exportName: 'Exportar em CSV',
            searchTooltip: 'Procurar',
            searchPlaceholder: 'Procurar'
        },
        header: {
            actions: 'Ações'
        },
        body: {
            filterRow: {
                filterTooltip: 'Filtrar'
            },
            editRow: {
                saveTooltip: "Salvar",
                cancelTooltip: "Cancelar",
                deleteText: "Tem certeza que deseja deletar esta linha?"
            },
            addTooltip: "Adicionar",
            deleteTooltip: "Deletar",
            editTooltip: "Editar",
            bulkEditTooltip: "Editar tudo",
            bulkEditApprove: "Salvar todas modificações",
            bulkEditCancel: "Ignorar todas trocas",
            emptyDataSourceMessage: 'Nenhum registro para exibir'
        },
    }


    async function sendDataHttp(){
        try{
            // console.log("enviando")
            setIsLoading(true)
            let data = { 
                'data': state.data
            }
            // const token = await sessionStorage.getItem('token')
            await api.post('/vezo/editSellers/sendData/'+store_id,data);
            setIsLoading(false)
            alert("Atualizado com sucesso!")
        }
        catch(err){
            console.log(err)
            setIsLoading(false)
            alert("Erro de atualização, recarregue a página!")
        }
    }

    return (
        <Paper className={classesMain.paper}>
            <Grid container spacing={3}  justifyContent={"center"} direction="row">
                <Grid item xs={12} md={1} lg={1}>
                <Tooltip title="Editar vendedores, adicionar ou desabilitar da loja! Sempre salve após as alterações!">
                    <IconButton aria-label="Selecionar" size="large">
                    <InfoIcon />
                    </IconButton>
                </Tooltip> 
                </Grid>
                <Grid item xs={12} md={10} lg={8}>
                <Title><PersonAddIcon/>Vendedores</Title>
                </Grid>
                <Grid item xs={12} md={1} lg={3}>
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        startIcon={<SaveIcon />}
                        onClick={sendDataHttp}
                    >
                        Salvar
                    </Button>
                </Grid>
            </Grid>
            <Grid item xs={12} md={12} lg={12}> 
                {isLoading ?
                    <div style={{paddingTop:'10px'}}>
                        <CircularProgress />
                    </div>
                
                    :
                    <MaterialTable
                    icons={tableIcons}
                    title="Vendedores"
                    columns={state.columns}
                    data={state.data}
                    localization={newLocalization}
                    editable={{
                        onRowAdd: (newData) =>
                        new Promise((resolve) => {
                            setTimeout(() => {
                            resolve();
                            setState((prevState) => {
                                const data = [...prevState.data];
                                data.push(newData);
                                return { ...prevState, data };
                            });
                            }, 1);
                        }),
                        onRowUpdate: (newData, oldData) =>
                        new Promise((resolve) => {
                            setTimeout(() => {
                            resolve();
                            if (oldData) {
                                setState((prevState) => {
                                const data = [...prevState.data];
                                data[data.indexOf(oldData)] = newData;
                                return { ...prevState, data };
                                });
                            }
                            }, 1);
                        }),
                        onRowDelete: (oldData) =>
                        new Promise((resolve) => {
                            setTimeout(() => {
                            resolve();
                            setState((prevState) => {
                                const data = [...prevState.data];
                                data.splice(data.indexOf(oldData), 1);
                                return { ...prevState, data };
                            });
                            }, 1);
                        }),
                    }}
                    />
                }
            </Grid>
            {
                (open)?
            
                <Grid item xs={12} md={12} lg={12}>
                    <UpdateAvatar open={open} store_id={store_id} setOpen={setOpen} selectedSeller={selectedSeller}/>
                </Grid>
             :
             null
            }
            
        </Paper >
    );}
